"use client";

import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import mermaid from "mermaid";

// Import your local image assets here
import ACT_light from "../assets/images/ACT Group Consoles small - light.svg";
import ACT_dark from "../assets/images/ACT Group Consoles small - dark.svg";
import ACT_group_consoles from "../assets/images/ACT-Group-Consoles.svg";
import console_screen_shot from "../assets/images/console-screen-shot.png";
import pointer_0_success from "../assets/images/pointers/pointer 0 Success.png";
import pointer_1_unknown_location from "../assets/images/pointers/pointer 1 Unknown Location.png";
import pointer_2_unsupported_location from "../assets/images/pointers/pointer 2 Unsupported Location.png";
import pointer_3_location_outside from "../assets/images/pointers/pointer 3 Location Outside.png";
import pointer_4_other from "../assets/images/pointers/pointer 4 Other.png";
import pointer_5_disabled from "../assets/images/pointers/pointer 5 Disabled.png";
import pointer_6_jailbroken from "../assets/images/pointers/pointer 6 Jailbroken.png";
import pointer_7_simulated_by_software from "../assets/images/pointers/pointer 7 Simulated By Software.png";
import pointer_8_undetermined_by_software from "../assets/images/pointers/pointer 8 Undetermined Middleware.png";
import pointer_9_developer_mode from "../assets/images/pointers/pointer 9 Developer Mode.png";
import pointer_10_device_blocked from "../assets/images/pointers/pointer 10 Device Blocked.png";
import pointer_11_account_blocked from "../assets/images/pointers/pointer 11 Account Blocked.png";
import pointer_12_proxy_detected from "../assets/images/pointers/pointer 12 Proxy Detected.png";
import pointer_13_device_blocked_globally from "../assets/images/pointers/pointer 13 Device Blocked Globally.png";
import pointer_14_ip_on_vpn_list from "../assets/images/pointers/pointer 14 IP on VPN List.png";
import pointer_15_emulator_detected from "../assets/images/pointers/pointer 15 Emulator Detected.png";
import pointer_16_invaild_ip from "../assets/images/pointers/pointer 16 Invalid IP.png";
import pointer_17_missing_sessionid from "../assets/images/pointers/pointer 17 Missing SessionId.png";
import pointer_18_invalid_sessionid from "../assets/images/pointers/pointer 18 Invalid SessionId.png";
import pointer_19_ip_not_matching from "../assets/images/pointers/pointer 19 IP Not Matching.png";
import pointer_20_expired_sessionid from "../assets/images/pointers/pointer 20 Expired SessionId.png";
import pointer_21_version_not_supported from "../assets/images/pointers/pointer 21 Version Not Supported.png";
import pie_1 from "../assets/images/pie1.png";
import pie_2 from "../assets/images/pie2.png";
import pie_3 from "../assets/images/pie3.png";
import pin_info from "../assets/images/pin-info.png";
import transactions from "../assets/images/transactions.png";
import QRcode from "../assets/images/verify/QRcode.png";
import Scan_QR_code_button from "../assets/images/verify/Scan QR code button.jpg";
import Scan_QR from "../assets/images/verify/Scan QR.jpg";
import Valid_Location from "../assets/images/verify/Valid Location.jpg";
import Screen_Session_Started from "../assets/images/verify/Screen Session Started.png";
import Session_Started from "../assets/images/verify/Session Started.jpg";
import Session_Expired from "../assets/images/verify/Session Expired.jpg";
import Extend_Session_Button from "../assets/images/verify/Extend Session Button.jpg";
import SI_pic1_light from "../assets/images/SI-pic1-light.png";
import SI_pic1_dark from "../assets/images/SI-pic1-dark.png";
import SI_pic2_light from "../assets/images/SI-pic2-light.png";
import SI_pic2_dark from "../assets/images/SI-pic2-dark.png";
import SI_pic3_light from "../assets/images/SI-pic3-light.png";
import SI_pic3_dark from "../assets/images/SI-pic3-dark.png";
import SI_pic4_light from "../assets/images/SI-pic4-light.png";
import SI_pic4_dark from "../assets/images/SI-pic4-dark.png";
import SI_pic5_light from "../assets/images/SI-pic5-light.png";
import SI_pic5_dark from "../assets/images/SI-pic5-dark.png";
import SI_redflag_light from "../assets/images/SI-redflag-light.png";
import SI_redflag_dark from "../assets/images/SI-redflag-dark.png";
import { useNavigate } from "react-router-dom";
import {
  createHeadingSlugger,
  getSamePageAnchorId,
  isListContinuation,
  isPipeTableStart,
  parsePipeTable,
} from "../utils/markdownHelpers";

// Map MDX src paths → imported asset URLs
const IMAGE_MAP = {
  "/images/ACT Group Consoles small - light.svg": ACT_light,
  "/images/ACT Group Consoles small - dark.svg": ACT_dark,
  "/images/ACT_group_consoles.svg": ACT_group_consoles,
  "/images/console-screen-shot.png": console_screen_shot,
  "/images/pointers/pointer 0 Success.png": pointer_0_success,
  "/images/pointers/pointer 1 Unknown Location.png": pointer_1_unknown_location,
  "/images/pointers/pointer 2 Unsupported Location.png":
    pointer_2_unsupported_location,
  "/images/pointers/pointer 3 Location Outside.png": pointer_3_location_outside,
  "/images/pointers/pointer 4 Other.png": pointer_4_other,
  "/images/pointers/pointer 5 Disabled.png": pointer_5_disabled,
  "/images/pointers/pointer 6 Jailbroken.png": pointer_6_jailbroken,
  "/images/pointers/pointer 7 Simulated By Software.png":
    pointer_7_simulated_by_software,
  "/images/pointers/pointer 8 Undetermined Middleware.png":
    pointer_8_undetermined_by_software,
  "/images/pointers/pointer 9 Developer Mode.png": pointer_9_developer_mode,
  "/images/pointers/pointer 10 Device Blocked.png": pointer_10_device_blocked,
  "/images/pointers/pointer 11 Account Blocked.png": pointer_11_account_blocked,
  "/images/pointers/pointer 12 Proxy Detected.png": pointer_12_proxy_detected,
  "/images/pointers/pointer 13 Device Blocked Globally.png":
    pointer_13_device_blocked_globally,
  "/images/pointers/pointer 14 IP on VPN List.png": pointer_14_ip_on_vpn_list,
  "/images/pointers/pointer 15 Emulator Detected.png":
    pointer_15_emulator_detected,
  "/images/pointers/pointer 16 Invalid IP.png": pointer_16_invaild_ip,
  "/images/pointers/pointer 17 Missing SessionId.png":
    pointer_17_missing_sessionid,
  "/images/pointers/pointer 18 Invalid SessionId.png":
    pointer_18_invalid_sessionid,
  "/images/pointers/pointer 19 IP Not Matching.png": pointer_19_ip_not_matching,
  "/images/pointers/pointer 20 Expired SessionId.png":
    pointer_20_expired_sessionid,
  "/images/pointers/pointer 21 Version Not Supported.png":
    pointer_21_version_not_supported,
  "/images/pie1.png": pie_1,
  "/images/pie2.png": pie_2,
  "/images/pie3.png": pie_3,
  "/images/pin-info.png": pin_info,
  "/images/transactions.png": transactions,
  "/images/verify/QRcode.png": QRcode,
  "/images/verify/Scan QR code button.jpg": Scan_QR_code_button,
  "/images/verify/Scan QR.jpg": Scan_QR,
  "/images/verify/Valid Location.jpg": Valid_Location,
  "/images/verify/Screen Session Started.png": Screen_Session_Started,
  "/images/verify/Session Started.jpg": Session_Started,
  "/images/verify/Session Expired.jpg": Session_Expired,
  "/images/verify/Extend Session Button.jpg": Extend_Session_Button,
  "/images/SI-pic1-light.png": SI_pic1_light,
  "/images/SI-pic1-dark.png": SI_pic1_dark,
  "/images/SI-pic2-light.png": SI_pic2_light,
  "/images/SI-pic2-dark.png": SI_pic2_dark,
  "/images/SI-pic3-light.png": SI_pic3_light,
  "/images/SI-pic3-dark.png": SI_pic3_dark,
  "/images/SI-pic4-light.png": SI_pic4_light,
  "/images/SI-pic4-dark.png": SI_pic4_dark,
  "/images/SI-pic5-light.png": SI_pic5_light,
  "/images/SI-pic5-dark.png": SI_pic5_dark,
  "/images/SI-redflag-light.png": SI_redflag_light,
  "/images/SI-redflag-dark.png": SI_redflag_dark,
};

function CodeBlock({ lang, code }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="md-code-block">
      <div className="md-code-header">
        {lang && <span className="md-code-lang">{lang}</span>}
        <button className="md-code-copy" onClick={handleCopy}>
          {copied ? (
            <DoneIcon
              style={{
                fontSize: "1rem",
              }}
            />
          ) : (
            <ContentCopyIcon
              style={{
                fontSize: "1rem",
              }}
            />
          )}
        </button>
      </div>
      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
}

// Parse ![alt](src) from a line
function parseImageLine(line) {
  const match = line.match(/^!\[([^\]]*)\]\(([^)]+)\)$/);
  if (!match) return null;

  const fullAlt = match[1];
  const src = match[2];

  const pipeParts = fullAlt.split("|");
  const alt = pipeParts[0].trim();

  let width = "";
  let height = "";
  let className = "";

  for (let i = 1; i < pipeParts.length; i++) {
    const part = pipeParts[i].trim();

    // class=no-border
    if (part.startsWith("class=")) {
      className = part.substring(6).trim();
    }

    // 300px x 200px
    else if (part.includes(" x ")) {
      const dims = part.split(" x ");
      width = dims[0]?.trim() || "";
      height = dims[1]?.trim() || "";
    }

    // 300px
    else {
      width = part;
    }
  }

  return {
    alt,
    src,
    width,
    height,
    className,
  };
}

// Resolve image src paths and convert width/height attrs to inline styles
function resolveHtmlImages(html) {
  // Convert markdown image syntax inside tables → proper <img> tags
  // Handles: ![alt|300px x200px](src) and ![alt](src)
  let resolved = html.replace(
    /!\[([^\]]*)\]\(([^)]+)\)/g,
    (_, fullAlt, src) => {
      const resolvedSrc = IMAGE_MAP[src] || src;
      const pipeParts = fullAlt.split("|");
      const alt = pipeParts[0];
      let styleStr = "";
      if (pipeParts[1]) {
        const sizePart = pipeParts[1].trim();
        if (sizePart.includes(" x ")) {
          const dims = sizePart.split(" x ");
          const w = dims[0] ? dims[0].trim() : "";
          const h = dims[1] ? dims[1].trim() : "";
          if (w) styleStr += `width:${w};`;
          if (h) styleStr += `height:${h};`;
        } else if (sizePart) {
          styleStr = `width:${sizePart};`;
        }
      }
      const styleAttr = styleStr ? ` style="${styleStr}"` : "";
      return `<img src="${resolvedSrc}" alt="${alt}"${styleAttr} />`;
    },
  );

  // Also resolve any remaining raw src paths in existing <img> tags
  resolved = resolved.replace(/src=["']([^"']+)["']/g, (match, src) => {
    const resolvedSrc = IMAGE_MAP[src];
    return resolvedSrc ? `src="${resolvedSrc}"` : match;
  });

  // Convert width/height HTML attributes to inline styles so rem/% values work
  resolved = resolved.replace(/<img([^>]*)>/gi, (fullTag, attrs) => {
    const widthMatch = attrs.match(/width=["']([^"']+)["']/i);
    const heightMatch = attrs.match(/height=["']([^"']+)["']/i);
    if (!widthMatch && !heightMatch) return fullTag;

    // Remove width/height attributes
    let newAttrs = attrs
      .replace(/\s*width=["'][^"']*["']/gi, "")
      .replace(/\s*height=["'][^"']*["']/gi, "");

    // Build inline style
    const styles = [];
    if (widthMatch) styles.push(`width:${widthMatch[1]}`);
    if (heightMatch) styles.push(`height:${heightMatch[1]}`);

    // Merge with existing style if present
    const existingStyle = newAttrs.match(/style=["']([^"']*)["']/i);
    if (existingStyle) {
      newAttrs = newAttrs.replace(
        /style=["'][^"']*["']/i,
        `style="${existingStyle[1]};${styles.join(";")}"`,
      );
    } else {
      newAttrs += ` style="${styles.join(";")}"`;
    }

    return `<img${newAttrs}>`;
  });

  return resolved;
}

// Parse a <table>...</table> block from lines starting at index i
// Returns { element, nextIndex }
function parseHtmlTable(lines, startIndex, keyRef) {
  const tableLines = [];
  let i = startIndex;
  while (i < lines.length) {
    tableLines.push(lines[i]);
    if (lines[i].trim().toLowerCase() === "</table>") {
      i++;
      break;
    }
    i++;
  }
  const raw = tableLines.join("\n");
  const resolved = resolveHtmlImages(raw);
  const element = (
    <div
      key={keyRef.k++}
      className="md-table-wrapper"
      dangerouslySetInnerHTML={{ __html: resolved }}
    />
  );
  return { element, nextIndex: i };
}

// Scroll to a heading on this page. The guide pages render inside a
// scrollable tab panel, so scrollIntoView (which scrolls every scrollable
// ancestor) is used rather than window.scrollTo or changing the URL hash.
export function scrollToAnchor(id) {
  const target = document.getElementById(id);
  if (target && typeof target.scrollIntoView === "function") {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

mermaid.initialize({ startOnLoad: false, theme: "default" });

function MermaidBlock({ chart }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (ref.current) {
      mermaid
        .render("mermaid-" + Math.random().toString(36).slice(2), chart)
        .then(({ svg }) => {
          ref.current.innerHTML = svg;
        });
    }
  }, [chart]);

  return <div ref={ref} className="md-mermaid" />;
}

function AccordionItem({ icon, title, body }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="md-accordion">
      <button className="md-accordion-header" onClick={() => setOpen(!open)}>
        <span className="md-accordion-title">
          {icon && (
            <i
              className={`fa-solid fa-${icon}`}
              style={{ marginRight: "8px" }}
            />
          )}
          {title}
        </span>
        <i className={`fa-solid fa-chevron-${open ? "up" : "down"}`} />
      </button>
      {open && (
        <div className="md-accordion-body">
          <MarkdownRenderer content={body} />
        </div>
      )}
    </div>
  );
}

function CardItem({ icon, title, body }) {
  return (
    <div className="md-card">
      <div className="md-card-header">
        {icon && <i className={`fa-solid fa-${icon}`} />}
        {title && <span className="md-card-title">{title}</span>}
      </div>
      <div className="md-card-body">
        <MarkdownRenderer content={body} />
      </div>
    </div>
  );
}

export default function MarkdownRenderer({ content, className = "" }) {
  const navigate = useNavigate();
  // keyRef lets helper functions increment the shared key counter
  const keyRef = { k: 0 };
  const lines = content.split("\n");
  const elements = [];
  let i = 0;
  let key = 0; // kept for backward compat but keyRef.k is used for new elements
  // Gives each heading a unique GitHub-style id so `[text](#id)` links work.
  const slugHeading = createHeadingSlugger();

  function inlineFormat(text) {
    const parts = [];
    let key = 0;

    const regex =
      /(\*\*\*(.+?)\*\*\*|\*\*(.+?)\*\*|\*(.+?)\*|`([^`]+)`|\[([^\]]+)\]\(([^)]+)\)|<br\s*\/?>|https?:\/\/[^\s<>"]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|<[a-z][a-z0-9]*\b[^>]*>[\s\S]*?<\/[a-z][a-z0-9]*>)/gi;

    let last = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > last) {
        parts.push(text.slice(last, match.index));
      }

      const token = match[0];

      if (/^<br/i.test(token)) {
        parts.push(<br key={key++} />);
      } else if (/^https?:\/\//i.test(token)) {
        parts.push(
          <a key={key++} href={token} target="_blank" rel="noopener noreferrer">
            {token}
          </a>,
        );
      } else if (
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(token)
      ) {
        parts.push(
          <a key={key++} href={`mailto:${token}`}>
            {token}
          </a>,
        );
      }

      // ***bold italic***
      else if (match[2]) {
        parts.push(
          <strong key={key++}>
            <em>{inlineFormat(match[2])}</em>
          </strong>,
        );
      }

      // **bold**
      else if (match[3]) {
        parts.push(<strong key={key++}>{inlineFormat(match[3])}</strong>);
      }

      // *italic*
      else if (match[4]) {
        parts.push(<em key={key++}>{inlineFormat(match[4])}</em>);
      }

      // `code`
      else if (match[5]) {
        parts.push(
          <code key={key++} className="md-inline-code">
            {match[5]}
          </code>,
        );
      }

      // [text](link)
      else if (match[6]) {
        const href = match[7];
        const anchorId = getSamePageAnchorId(href);

        if (anchorId) {
          parts.push(
            <a
              key={key++}
              href={href}
              onClick={(e) => {
                // Let Cmd/Ctrl/Shift/middle clicks behave as normal links.
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
                  return;
                }
                e.preventDefault();
                scrollToAnchor(anchorId);
              }}
            >
              {inlineFormat(match[6])}
            </a>,
          );
        } else if (href.startsWith("/") || href.startsWith(".")) {
          parts.push(
            <a
              key={key++}
              href={href}
              onClick={(e) => {
                e.preventDefault();
                navigate(href);
              }}
            >
              {inlineFormat(match[6])}
            </a>,
          );
        } else {
          parts.push(
            <a
              key={key++}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {inlineFormat(match[6])}
            </a>,
          );
        }
      }

      // HTML element
      else if (token.startsWith("<")) {
        const html = token.match(
          /^<([a-z][a-z0-9]*)\s*([^>]*)>([\s\S]*?)<\/\1>$/i,
        );

        if (html) {
          const [, tag, attrs, inner] = html;

          const props = { key: key++ };

          const classMatch = attrs.match(/class=["']([^"']+)["']/i);
          if (classMatch) props.className = classMatch[1];

          const styleMatch = attrs.match(/style=["']([^"']+)["']/i);
          if (styleMatch) {
            props.style = Object.fromEntries(
              styleMatch[1]
                .split(";")
                .filter(Boolean)
                .map((s) => {
                  const [k, v] = s.split(":");
                  return [
                    k.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase()),
                    v.trim(),
                  ];
                }),
            );
          }

          parts.push(React.createElement(tag, props, inlineFormat(inner)));
        } else {
          parts.push(token);
        }
      }

      last = regex.lastIndex;
    }

    if (last < text.length) {
      parts.push(text.slice(last));
    }

    return parts;
  }

  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim(); // add this

    // HTML Table
    if (
      trimmed.toLowerCase() === "<table>" ||
      trimmed.toLowerCase().startsWith("<table ")
    ) {
      const { element, nextIndex } = parseHtmlTable(lines, i, { k: key });
      key++;
      elements.push(element);
      i = nextIndex;
      continue;
    }

    // GFM pipe table (header row, delimiter row, body rows)
    if (isPipeTableStart(lines, i)) {
      const { header, align, rows, nextIndex } = parsePipeTable(lines, i);
      const cellStyle = (col) =>
        align[col] ? { textAlign: align[col] } : undefined;
      elements.push(
        <div key={key++} className="md-table-wrapper md-pipe-table">
          <table>
            <thead>
              <tr>
                {header.map((cell, col) => (
                  <th key={col} style={cellStyle(col)}>
                    {inlineFormat(cell)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, r) => (
                <tr key={r}>
                  {row.map((cell, col) => (
                    <td key={col} style={cellStyle(col)}>
                      {inlineFormat(cell)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>,
      );
      i = nextIndex;
      continue;
    }

    // Image
    // const imgData = parseImageLine(line.trim());
    const imgData = parseImageLine(trimmed);
    if (imgData) {
      const resolvedSrc = IMAGE_MAP[imgData.src] || imgData.src;
      const imgStyle = {};
      if (imgData.width) imgStyle.width = imgData.width;
      if (imgData.height) imgStyle.height = imgData.height;
      elements.push(
        <img
          key={key++}
          src={resolvedSrc}
          alt={imgData.alt}
          className={`md-img ${imgData.className || ""}`}
          style={Object.keys(imgStyle).length ? imgStyle : undefined}
        />,
      );
      i++;
      continue;
    }

    // Headings
    if (/^#{1,6}\s/.test(trimmed)) {
      const level = trimmed.match(/^(#+)/)[1].length;
      const text = trimmed.replace(/^#+\s/, "");
      const Tag = `h${level}`;
      elements.push(
        <Tag key={key++} id={slugHeading(text)} className={`md-h${level}`}>
          {inlineFormat(text)}
        </Tag>,
      );
      i++;
      continue;
    }

    // Card
    if (trimmed.startsWith("%%CARD|")) {
      const raw = trimmed.slice("%%CARD|".length).slice(0, -2);
      const firstPipe = raw.indexOf("|");
      const secondPipe = raw.indexOf("|", firstPipe + 1);
      const icon = raw.slice(0, firstPipe);
      const title = decodeURIComponent(raw.slice(firstPipe + 1, secondPipe));
      const body = raw.slice(secondPipe + 1);
      elements.push(
        <CardItem key={key++} icon={icon} title={title} body={body} />,
      );
      i++;
      continue;
    }

    // Horizontal rule
    if (/^[-_]{3,}$/.test(trimmed)) {
      elements.push(<hr key={key++} className="md-hr" />);
      i++;
      continue;
    }

    // Blockquote
    if (trimmed.startsWith(">")) {
      const text = trimmed.replace(/^>\s?/, "");
      elements.push(
        <blockquote key={key++} className="md-blockquote">
          {inlineFormat(text)}
        </blockquote>,
      );
      i++;
      continue;
    }

    // Accordion
    if (trimmed.startsWith("%%ACCORDION|")) {
      const raw = trimmed.slice("%%ACCORDION|".length).slice(0, -2);
      const separatorIndex = raw.indexOf("|");
      const rest = raw.slice(separatorIndex + 1);
      const separatorIndex2 = rest.indexOf("|");
      const icon = raw.slice(0, separatorIndex);
      const title = decodeURIComponent(rest.slice(0, separatorIndex2)); // decode
      const body = rest.slice(separatorIndex2 + 1);
      elements.push(
        <AccordionItem key={key++} icon={icon} title={title} body={body} />,
      );
      i++;
      continue;
    }

    // Iframe
    if (trimmed.startsWith("%%IFRAME|")) {
      const parts = trimmed.slice("%%IFRAME|".length).slice(0, -2).split("|");
      const src = parts[0];
      const width = parts[1];
      const height = parts[2];
      elements.push(
        <iframe
          key={key++}
          src={src}
          width={width}
          height={height}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="embedded-content"
          style={{ display: "block", maxWidth: "100%" }}
        >
          Loading…
        </iframe>,
      );
      i++;
      continue;
    }

    // Fenced code block
    if (trimmed.startsWith("```")) {
      const lang = trimmed.slice(3).trim();
      const codeLines = [];
      i++;
      while (i < lines.length && !lines[i].trim().startsWith("```")) {
        // make sure .trim() is here
        codeLines.push(lines[i]);
        i++;
      }
      const codeString = codeLines.join("\n");

      const isMermaid =
        lang === "mermaid" ||
        codeString.trim().startsWith("flowchart") ||
        codeString.trim().startsWith("sequenceDiagram") ||
        codeString.trim().startsWith("graph");

      elements.push(
        isMermaid ? (
          <MermaidBlock key={key++} chart={codeString} />
        ) : (
          <CodeBlock key={key++} lang={lang} code={codeString} />
        ),
      );
      i++;
      continue;
    }

    // Unordered list
    if (/^[-*+]\s/.test(trimmed)) {
      const items = [];
      while (i < lines.length) {
        const t = lines[i].trim();
        if (/^[-*+]\s/.test(t)) {
          const itemKey = i;
          let itemText = t.replace(/^[-*+]\s/, "");
          i++;
          while (i < lines.length && isListContinuation(lines[i])) {
            itemText += " " + lines[i].trim();
            i++;
          }
          items.push(<li key={itemKey}>{inlineFormat(itemText)}</li>);
        } else if (t === "") {
          const next = lines.slice(i + 1).find((l) => l.trim() !== "");
          if (next && /^[-*+]\s/.test(next.trim())) {
            i++;
          } else {
            break;
          }
        } else {
          break;
        }
      }
      elements.push(
        <ul key={key++} className="md-ul">
          {items}
        </ul>,
      );
      continue;
    }

    // Ordered list
    if (/^\d+\.\s/.test(trimmed)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i].trim())) {
        const itemKey = i;
        let itemText = lines[i].trim().replace(/^\d+\.\s/, "");
        i++;
        while (i < lines.length && isListContinuation(lines[i])) {
          itemText += " " + lines[i].trim();
          i++;
        }
        items.push(<li key={itemKey}>{inlineFormat(itemText)}</li>);
      }
      elements.push(
        <ol key={key++} className="md-ol">
          {items}
        </ol>,
      );
      continue;
    }

    // Empty line
    if (trimmed === "") {
      i++;
      continue;
    }

    // Paragraph
    const paraLines = [];
    while (
      i < lines.length &&
      lines[i].trim() !== "" &&
      !/^#{1,6}\s/.test(lines[i].trim()) &&
      !lines[i].trim().startsWith("```") &&
      !/^[-*+]\s/.test(lines[i].trim()) &&
      !/^\d+\.\s/.test(lines[i].trim()) &&
      !/^[-_]{3,}$/.test(lines[i].trim()) &&
      !lines[i].trim().startsWith(">") &&
      !parseImageLine(lines[i].trim()) &&
      !isPipeTableStart(lines, i)
    ) {
      paraLines.push(lines[i]);
      i++;
    }

    if (paraLines.length) {
      elements.push(
        <p key={key++} className="md-p">
          {inlineFormat(paraLines.join(" "))}
        </p>,
      );
    }
  }

  return <div className={`md-content ${className}`}>{elements}</div>;
}
